<template>
  <MinimalLayout :loading="step === 'loading'">
    <SuccessStatus
      v-if="step === 'success'"
      :message="t('link.accountSynchronized')"
      :subtitle="t('link.closePage')"
    />

    <ErrorStatus v-else>{{ t("link.errorOccurred") }}</ErrorStatus>
  </MinimalLayout>
</template>

<script lang="ts" setup>
import ErrorStatus from "@/components/ErrorStatus.vue";
import MinimalLayout from "@/components/MinimalLayout.vue";
import SuccessStatus from "@/components/SuccessStatus.vue";
import { useI18n } from "@/composables/useI18n";
import { captureException } from "@sentry/vue";
import { ref } from "vue";
import { useRoute } from "vue-router";

const { t } = useI18n();
const route = useRoute();

const step = ref<"loading" | "error" | "success">("loading");

(() => {
  try {
    // Check errors from query, https://docs.powens.com/api-reference/overview/webview#add-connection-flow
    if (route.query.error) {
      console.error(
        `Got error ${typeof route.query.error === "string" ? route.query.error : JSON.stringify(route.query.error)} from query in Powens Return`,
        {
          query: route.query,
        },
      );
      captureException(
        new Error(
          `Got error ${typeof route.query.error === "string" ? route.query.error : JSON.stringify(route.query.error)} from query in Powens Return`,
        ),
        {
          extra: { query: route.query },
        },
      );
      step.value = "error";
      return;
    }

    step.value = "success";
  } catch (cause) {
    const error = new Error("Error in Link PowensReturn init function", { cause });
    console.error(error);
    captureException(error);
    step.value = "error";
  }
})();
</script>
